<template>
 <div class="mission-vision row">
    <div class="vision p-3 col-12 col-md-6 row">
      <div class="content">
        <img class="logo" alt="Mission logo" src="@/assets/vision.svg">
        <h3>Our Vision</h3>
        <p>
          Our foundation is to provide holistic support and assistance for all especially vulnerable people through empowerment and inclusion.
        </p>
      </div>
    </div>
    <div class="contact p-3 col-12 col-md-6 row">
      <div class="content">
        <img class="logo" alt="Vision logo" src="@/assets/mission.svg">
        <h3>Become a volunteer</h3>
        <p class="text-center">
          Get in touch:<br/>
          Phone: +356 7940 5440 <br/>
          E-mail: revivemalta@yahoo.com
        </p>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.mission-vision {
  .vision {
    background: var(--primary-color);
  }

  .contact {
    background: var(--secondary-color);
  }

  .contact,
  .vision { 
    --bs-gutter-x: 0;
    display: flex;
    color: white;
   
    .logo {
      width: 30%;
      max-width: 80%;
      max-height: 7rem;
      padding: 0;
      margin-left: 35%;
    }

    h3 {
      text-align: center;
    }

    .content {
      align-content: center;
      padding: 0 3rem;
    }
  }
}
</style>